import * as endpoints from '@piconetworks/pkg-endpoints'
import createAsyncSaga from '@/utils/store/createAsyncSaga'

const name = 'featureFlags'

export {
    name,
    createAsyncSaga,
    endpoints,
}